<template>
  <div :class="['invite-page']">
    <p class="invite-null" v-if="loading">Checking invite...</p>
    <div v-if="!loading">
      <div v-if="inviteFound">

        <div class="letter">
          <a href="/" target="_blank" rel="noopener" class="letter-logo">
            <svg width="62" height="62" viewBox="0 0 62 62" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_5682_6969)">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M13.175 22.6377H48.825C53.4432 22.6377 57.1872 26.3816 57.1872 31C57.1872 35.6183 53.4432 39.3622 48.825 39.3622H13.175C8.55666 39.3622 4.81275 35.6183 4.81275 31C4.81275 26.3816 8.55666 22.6377 13.175 22.6377ZM0 31C0 23.7236 5.89864 17.825 13.175 17.825H48.825C56.1015 17.825 62 23.7236 62 31C62 38.2763 56.1015 44.175 48.825 44.175H13.175C5.89864 44.175 0 38.2763 0 31ZM13.1758 28.6757C11.8917 28.6757 10.8508 29.7166 10.8508 31.0007C10.8508 32.2848 11.8917 33.3257 13.1758 33.3257H48.8258C50.1099 33.3257 51.1508 32.2848 51.1508 31.0007C51.1508 29.7166 50.1099 28.6757 48.8258 28.6757H13.1758Z" fill="white"/>
              </g>
              <defs>
              <clipPath id="clip0_5682_6969">
              <rect width="62" height="62" fill="white"/>
              </clipPath>
              </defs>
            </svg>
          </a>
          <div class="letter-header">
            <div class="letter-header__row">
              To:&nbsp;&nbsp;&nbsp;{{ data.invite.name }}
            </div>
            <div class="letter-header__row">
              From:&nbsp;USB Club
            </div>
            <div class="letter-header__row">
              Date:&nbsp;{{ inviteYear }}
            </div>
          </div>

          <div class="letter-content">
          
          <div class="letter-content-left">
              <p class="large">With a warm welcome,</p>
              <br>
              <p>The Desktop app pairs with your USB to open up a social file exchange. The network of USB Club is still being discovered, and we look forward to exploring it together. If you have any questions, reach out to staff@usb.club</p>
              <br>
              <br>
              <p>
                Download the Desktop app to continue your journey, and we'll see you inside.
              </p>
              <br/>
              <br/>
              <p>For memory's sake, <br>USB Club</p>
            </div>
            <div class="letter-content-right">
              <div class="download-box">
                <img src="/figures/console-update-icon_glowbe.png" class="download-box__icon" />
                <p v-if="isMobile" class="mobile-download">
                  <span class="mobile-download-small">Looks like you're on mobile</span><br/><span>Head to your Laptop to download the Desktop app.</span>
                </p>
                <p v-if="!isMobile && !data.invite.intel">
                  <button class="button button-inline letter-button" @click="fetchDownload('arm64')">Download Desktop App</button>
                </p>
                <p v-if="!isMobile && data.invite.intel">
                  <button class="button button-inline letter-button" @click="fetchDownload('x64')">Download Desktop App</button>
                </p>
              </div>
            </div>
          </div>
        </div>

      </div>

      <div v-if="!inviteFound && !error">
        <br>
        <br>
        <p class="invite-null"><b>No invite was found.</b></p>
        <p class="invite-null">You may have already downloaded the Desktop app, which was previously named Console.<br>Try checking your Applications folder or reach out for support@usb.club</p>
      </div>

      <div v-if="error">
        <p class="invite-null">No invite status found.</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Invite",
  props: ["code"],
  data() {
    return {
      copiedToClipboard: false,
      hoveringCopy: false,
      loading: false,
      error: null,
      data: null,
      inviteFound: false,
      baseApiUrl: "https://panel-0a.herokuapp.com/api/v1"
    };
  },
  computed: {
    inviteYear(){
      if(!this.data.invite){
        return null;
      }

      if (this.data && this.data.invite && this.data.invite.createdAt) {
        const date = new Date(this.data.invite.createdAt);
        console.log(date)
        const year = date.getUTCFullYear(); // Output: 2023
        console.log(year)
        return year;
      }
      return null;
    },
    isMobile(){
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(window.navigator.userAgent);
    },
  },
  watch: {},
  mounted() {
    if(this.code){
      this.fetchInvite();
    }

    // uncomment for testing 
    // this.data = { "invite": {
    //     "id": "Invite-OK",
    //     "name": "OK OK",
    //     "phone": "ok",
    //     "email": "ok@ok.ok",
    //     "downloadCode": "okok-okok-okok",
    //     "downloaded": true,
    //     "expiry": "2024-09-13T02:48:47.388Z",
    //     "user_id": null,
    //     "intel": true,
    //     "createdAt": "2023-09-13T02:49:41.259Z",
    //     "updatedAt": "2023-09-13T02:49:55.938Z"
    // }};
    // this.inviteFound = true;
  },
  methods: {
    fetchInvite() {
      this.loading = true;

      let apiUrl = this.baseApiUrl + "/invite/fetch";
      fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ downloadCode: this.code })
      })
        .then(response => {
          if (response.status === 404) {
            console.log("Invite not found");
            this.inviteFound = false;
            return null;
          } else {
            this.inviteFound = true;
          }
          return response.json();
        })
        .then(data => {
          this.data = data;
          this.loading = false;
        })
        .catch(err => {
          console.log("failed to fetch", err);
          this.error = err.message || err;
          this.loading = false;
        });
    },
    fetchDownload(arch) {
      console.log('Selected arch:', arch);
      let downloadInviteUrl = this.baseApiUrl + `/invite/download?invite=${this.data.invite.downloadCode}&arch=${arch}`;
      
      // Ensure that the call causes a non-error http response before performing redirect.
      fetch(downloadInviteUrl, {
        method: "GET",
        redirect: 'manual' // We don't want to do the redirect, just ensure it happens.
      })
        .then(response => {

          // If 401, the invite is not found.
          // Hypothetically this shouldn't happen since this page can only appear with a valid invite code.
          if (response.status === 401) {
            console.error("Invite not found");
            this.error = "Invite not found";
            return null;
            
          // If redirect was successful, perform the redirect
          } else if (response.status === 302 || response.type === 'opaqueredirect') {
            window.location.href = downloadInviteUrl; // perform redirect
            return null
          
          // If not 401 or redirect, something went wrong.
          } else {
            console.error(`Unknown response from server: ${response}`);
            this.error = "Invite not found";
            return null;
          }
        })
        .catch(err => {
          console.error("failed to download dmg", err);
          this.error = err.message || err;
        });
    },
  }
};
</script>

<style>

.invite-page {
  padding-left: 2.4rem;
  padding-right: 2.4rem;
  box-sizing: border-box;
}

.letter {
  max-width: 712px;
  margin-bottom: 8rem;
}

.letter-logo {
  margin-top: 2.4rem;
  margin-bottom: 2.4rem;
  display: block;
  transition: all 200ms ease-in-out;
}

.letter-logo:hover {
  opacity: 0.7;
  cursor: pointer;
}

.letter-header {
  border-top: 1px solid #4F4F4F;
  padding-top: 2.4rem;
  padding-bottom: 4rem;
}

.letter-header__row {
  color: #CDCDCD;
  font-family: "ISO", monospace;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
}

.invite-page .button-inline {
  width: fit-content;
  margin-right: 8px;
}

.invite-page p {
  color: #BABABA;
  font-family: "Good", sans-serif;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 30px */
}

.invite-page p.large {
  color: #F6F6F6;
  font-family: "Good", sans-serif;
  font-size: 22px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
}

.invite-null {
  margin-top: 4rem;
}

.letter button.letter-button {
  font-family: "ISO";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 150%;
  text-align: center;
  color: #FFFFFF;
  padding-left: 2rem;
  padding-right: 2rem;
  padding-top: 1rem;
  padding-bottom: 1.2rem;
  background: #249EF6;
  box-shadow: inset 0px -2.91986px 5.83973px #114D6F, inset 0px 2.91986px 2.91986px #4CD7F6;
  border: none;
  border-radius: 0.3rem;
  text-shadow: 0px 2px 3px #17496D;

  transition: all 100ms ease-in-out;
}

.letter button.letter-button:hover {
  cursor: pointer;
  background: #4AAFF7;
}

.letter button.letter-button:active {
  background: #249EF6;
  box-shadow: inset 0px 2.92px 4.84px #114D6F, inset 0px -2.92px 7.92px #67BCF9;
}

.letter button.letter-button:disabled {
  cursor: default;
  background: #249EF6;
  opacity: 0.6;
  text-shadow: 0px 0px 0px #17496d00;
}

.letter button.letter-button.small {
  font-size: 1.4rem;
  line-height: 150%;
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.letter-content {
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 24px;
}

.letter-content-right {
  padding-top: 0;
  padding-right: 24px;
  padding-bottom: 0;
  padding-left: 24px;
  box-sizing: border-box;
  height: fit-content;
  display: flex;
  justify-content: space-between;
  width: 100%;
  grid-gap: 1.6rem;
}

.download-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding-top: 0;
  padding-bottom: 0;
  box-sizing: border-box;
}

.download-box__icon {
  width: 160px;
  height: auto;
  margin-top: -4rem;
}

.registration-code {
  width: 100%;
}

/* mobile media query */ 
@media screen and (max-width: 768px) {
  .letter-content-right {
    flex-direction: column;
  }
}

p.mobile-download {
  text-align: center;
  color: #3ca0e8;
}

.mobile-download-small {
  font-size: 16px;
  font-weight: bold;
}

.code--on-mobile {
  opacity: 0.5;
}
</style>
